import lodash from "lodash";
import { FormInformation } from "@/modules/GeneralRules/models/FormInformationMapped.model";
import { LogicalField } from "@/modules/GeneralRules/models/LogicalField.model";
import FieldValue from "@/shared/components/FieldValue/FieldValue.vue";
import { FORM_VALIDATORS } from "@/shared/constants/FormConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Vuetify from "vuetify";
import {
  FORM_ACTION_CONSTANTS,
  LOGICAL_FIELD_INIT
} from "../../constants/FormActionModal.constants";
import { DATA_TYPES } from "@/modules/GeneralRules/constants/GeneralRulesConstants";

Vue.use(Vuetify);
@Component({ name: "LogicOperationComponent", components: { FieldValue } })
export default class LogicOperationComponent extends Vue {
  @Prop({ default: 0 }) index!: number;
  @Prop() logicalField!: LogicalField;
  @Prop() formInformationArray!: FormInformation[];

  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  requiredFieldObject = [FORM_VALIDATORS.REQUIRED_OBJECT];

  SELECT_INFORMATION = FORM_ACTION_CONSTANTS.LABELS.SELECT_INFORMATION;
  SELECT_OPERATOR = FORM_ACTION_CONSTANTS.LABELS.SELECT_OPERATOR;
  SELECT_CONNECTOR = FORM_ACTION_CONSTANTS.LABELS.SELECT_CONNECTOR;
  VALUE_INPUT = FORM_ACTION_CONSTANTS.LABELS.VALUE_INPUT;
  LOGIC_OPERATORS = [
    FORM_ACTION_CONSTANTS.COMPARATION_OPERATION.MORE_OR_EQUAL,
    FORM_ACTION_CONSTANTS.COMPARATION_OPERATION.MORE_THAN,
    FORM_ACTION_CONSTANTS.COMPARATION_OPERATION.LESS_THAN,
    FORM_ACTION_CONSTANTS.COMPARATION_OPERATION.LESS_OR_EQUAL,
    FORM_ACTION_CONSTANTS.COMPARATION_OPERATION.DIFFERENT,
    FORM_ACTION_CONSTANTS.COMPARATION_OPERATION.EQUAL
  ];

  CONNECTORS = [
    FORM_ACTION_CONSTANTS.LOGIC_CONNECTORS.AND,
    FORM_ACTION_CONSTANTS.LOGIC_CONNECTORS.OR
  ];

  selectedFormInformation = "";
  localLogicalField: LogicalField = lodash.cloneDeep(LOGICAL_FIELD_INIT);
  type = "";

  mounted() {
    this.localLogicalField = this.logicalField;
    this.changedType(this.localLogicalField.key as FormInformation);
  }

  @Watch("logicalField")
  logicalFieldsWatcher(value: LogicalField) {
    this.localLogicalField = value;
  }

  @Watch("localLogicalField")
  localFieldsWatcher(value: LogicalField) {
    this.$emit(
      FORM_ACTION_CONSTANTS.EVENTS.OPERATIONS.LOGICAL_UPDATE,
      value,
      this.index
    );
  }

  formInformationFilter() {
    return this.formInformationArray && this.formInformationArray.length > 0
      ? this.formInformationArray.filter(
          formInformation =>
            formInformation.operation !==
            FORM_ACTION_CONSTANTS.INFO_OPERATION.GET_MULTIPLE.key
        )
      : [];
  }

  connectorSelected() {
    if (this.logicalField.connector) {
      this.$emit(
        FORM_ACTION_CONSTANTS.EVENTS.OPERATIONS.ADD_LOGICAL_FIELD,
        this.index
      );
    } else {
      this.$emit(
        FORM_ACTION_CONSTANTS.EVENTS.OPERATIONS.DELETE_LOGICAL_FIELD,
        this.index
      );
    }
  }

  changedType(formInformation: FormInformation) {
    this.type = formInformation
      ? formInformation.dataType
        ? formInformation.dataType
        : DATA_TYPES.STRING
      : DATA_TYPES.STRING;
  }
}
